module.exports = __webpack_public_path__ + "img/LammHalbe_Instagram_201780540_01.95eb8d35.jpg";